import React from 'react';
import { FaChartBar } from 'react-icons/fa';

const ReportsTab = () => {
  return (
    <div className="bg-gray-900 h-full p-12 text-center text-white rounded">
      <div className="flex flex-col items-center justify-center space-y-4">
        <FaChartBar className="text-green-400 text-6xl" />
        <h1 className="text-4xl font-extrabold text-green-400">Reports</h1>
        <p className="text-lg text-gray-300">
          Our intelligent reporting dashboards and analytics are{' '}
          <span className="text-yellow-400 font-semibold">coming soon</span>.
        </p>
        <p className="text-sm text-gray-500 max-w-xl mt-2">
          You’ll be able to visualize performance, trends, and compliance metrics across your entire QA process.
        </p>
      </div>
    </div>
  );
};

export default ReportsTab;

